Wee.routes.map({
	'we-see-a-teacher': {
		'$slug': [
			'common',
			'landingPage2',
			'form',
			'newsletter',
			'quotes',
			'modal',
			'quoteModal',
			function() {
				$('ref:form').csrf(),
				$('ref:newsletter').csrf();
			}
		]
	},
	'cs-subject-spec': {
		'$root': [
			'subject-form',
			function() {
				$('ref:submissionForm').csrf();
			}
		]
	},
	'ahigherlearning': {
		'$root':
			function() {
			$('ref:higherLearningForm').csrf();
		}
	},
	'preschool-curriculum': {
		'$root':
			function() {
			$('ref:preschoolForm').csrf();
		}
	},
	'christmas-landing': {
		'$root':
			function() {
			$('ref:christmasNewsletterForm').csrf();
		}
	},
	'christmas-card': {
		'$root':
			function() {
			$('ref:cardForm').csrf();
		}
	},
	'switch': {
		'$any': [
			'common',
			function() {
				$('ref:switchConnectForm').csrf();
			}
		]
	},
	'$any': [
		'seasonalPromo',
		function() {
			if (Wee.$contains('ref:main', 'ref:reusableForm')) {
				$('ref:reusableForm').csrf();
			}
		}
	],
	'2021-christmas': {
		'$any': [
			function() {
				if (Wee.$contains('ref:twentyFiveDaysOfJoyForm')) {
					$('ref:twentyFiveDaysOfJoyForm').csrf();
				}
			}
		]
	}
});

Wee.ready('routes:run');
